import axios from '@/utils/axiosReq'
import URL from './urlConstants'

class HomeFetch {
  getCanViewIds () {
    return axios.get(URL.HOME.NOTICE_GROUP)
  }
  getNoticInfo (urlParam) {
    return axios.get(URL.HOME.NOTICE_VIEW + '/' + urlParam)
  }
  getNoticHasView (urlParam) {
    return axios.get(URL.HOME.NOTICE_HAS_VIEW + '/' + urlParam)
  }
  getOrders () {
    return axios.get(URL.HOME.ORDERS)
  }
  getUserNotice () {
    return axios.get(URL.HOME.USERNOTICE_GET)
  }
  saveUserNotice (params) {
    return axios.post(URL.HOME.USERNOTICE_SAVE, params)
  }
  // 
  getSalePlan (params) {
    return axios.get(URL.HOME.SALE_PLAN, params)
  }
  getReturnKPI (params) {
    return axios.get(URL.HOME.RETURN_SUGGEST, params)
  }
  getDeptInfo (params) {
    return axios.get(URL.HOME.DEPT_INFO, params)
  }
  getIhsKPI (params) {
    return axios.get(URL.HOME.IHS_KPI, params)
  }
  getSalePlanForWeek (params) {
    return axios.get(URL.HOME.SALE_PLAN_FOR_WEEK, params)
  }
  getPbsKPI (params) {
    return axios.get(URL.HOME.PBS_KPI, params)
  }
  getGMV (params) {
    return axios.get(URL.HOME.GMV_INFO, params)
  }
  getDateDt (params) {
    return axios.get(URL.HOME_NEW.DATE_DT, params)
  }
  getSales (params) {
    return axios.get(URL.HOME_NEW.SALES, params)
  }
  getMap (params) {
    return axios.get(URL.HOME_NEW.MAP, params)
  }
  getStock (params) {
    return axios.get(URL.HOME_NEW.STOCK, params)
  }
  getAcross (params) {
    return axios.get(URL.HOME_NEW.ACROSS, params)
  }
  getDtList (urlParam, params) {
    return axios.get(URL.HOME_NEW.DT_LIST + '/' + urlParam, params)
  }
  getCategorys (params) {
    return axios.get(URL.HOME_NEW.CATEGORY_LIST, params)
  }
}

const home = new HomeFetch()
export default home
